import { App, Button, Card, Col, Input, message, Pagination, Row, Select, Space, Spin, Table, Popconfirm } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DELETE_ACCOUNT, LIST_DELETE_ACCOUNT_REQUEST } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { formatToIST } from "../../../helper/CommonHelper";
import dayjs from "dayjs";


function AccountDeleteRequests() {
  const { notification } = App.useApp();
  const { page } = useParams();


  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_count, set_total_count] = useState("");
  // fillter state
  const [placeholder, set_placeholder] = useState("Search by phone");
  const [search_query_key, set_search_query_key] = useState('contact_no');
  const [search_query_value, set_search_query_value] = useState('');
  const [page_size, set_page_size] = useState(10);



  const fetchResults = useCallback((search_key, search_value) => {
    debounce(async () => {
      try {
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append(search_key, search_value);
        FORM_DATA.append("per_page", page_size);
        FORM_DATA.append("page", 1);
        const API_CALL = await LIST_DELETE_ACCOUNT_REQUEST(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_count(API_CALL?.data?.total_count);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
      }
    }, 500)(); // Call debounce immediately
  }, [page_size]);



  const LIST_API = async () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("per_page", page_size);
    const API_CALL = await LIST_DELETE_ACCOUNT_REQUEST(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_count(API_CALL?.data?.total_count);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, [page, page_size]);



  const selectBefore = (
    <Select
      defaultValue="Phone"
      onChange={(value) => {
        // if (value === 'Name') {
        //   set_search_query_key('name');
        //   set_placeholder("Search by name");
        // }
        // if (value === 'Email') {
        //   set_search_query_key('email');
        //   set_placeholder("Search by email");
        // }
        if (value === 'Phone') {
          set_search_query_key('contact_no');
          set_placeholder("Search by contact no.");
        }
      }}
    >
      {/* <Select.Option value="Name">Name</Select.Option> */}
      {/* <Select.Option value="Email">Email</Select.Option> */}
      <Select.Option value="Phone">Phone</Select.Option>
    </Select>
  );


  const pagination_on_change = async (data, size) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", data);
    FORM_DATA.append("per_page", size);
    FORM_DATA.append(search_query_key, search_query_value);
    const API_CALL = await LIST_DELETE_ACCOUNT_REQUEST(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_count(API_CALL?.data?.total_count);
      set_pagination_loader(false);
    } else {
      set_pagination_loader(false);
    }
  }

  const handleInput = (e) => {
    const value = e.target.value;
    set_search_query_value(value)

    // if (search_query_key === 'name') {
    //   fetchResults('name', value)
    // }
    // if (search_query_key === 'email') {
    //   fetchResults('email', value)
    // }
    if (search_query_key === 'contact_no') {
      fetchResults('contact_no', value)
    }
  };


  const getDaysLeft = (createdAt) => {
    const createdDate = dayjs(createdAt).startOf("day");
    const today = dayjs().startOf("day");

    const daysPassed = today.diff(createdDate, "day");
    const daysLeft = 30 - daysPassed;

    if (daysLeft <= 0) {
      return {
        text: "Expired",
        color: "red",
        expired: true,
      };
    }

    if (daysLeft <= 5) {
      return {
        text: `${daysLeft} Days Left`,
        color: "#ff4d4f",
        expired: false,
      };
    }

    if (daysLeft <= 10) {
      return {
        text: `${daysLeft} Days Left`,
        color: "#fa8c16",
        expired: false,
      };
    }

    return {
      text: `${daysLeft} Days Left`,
      color: "#52c41a",
      expired: false,
    };
  };

  const columns = [
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (text, record) => (
        <span>
          {formatToIST(record.created_at)}
        </span>
      ),
    },
    {
      title: "Days Left",
      dataIndex: "created_at",
      render: (text, record) => {
        const days = getDaysLeft(record.created_at);

        return (
          <>
            {
              record.status === false ? <>
                <span style={{color:"red"}}>Account deleted </span>
              </> : <>
                <span
                  style={{
                    color: days.color,
                    fontWeight: "600",
                  }}
                >
                  {days.text}
                </span>
              </>
            }
          </>

        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span>
          {record?.learner_details?.first_name} {record?.learner_details?.last_name}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text, record) => (
        <span>
          {record?.learner_details?.email}
        </span>
      ),
    },
    {
      title: "Organization",
      dataIndex: "organization",
      render: (text, record) => <span>{record?.learner_details?.organization}</span>,
    },

    {
      title: "Phone",
      dataIndex: "contact_no",
      render: (text, record) => <span>{record.contact_no}</span>,
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">

          <Popconfirm
            title="Do you really want to delete App User?"
            onConfirm={() => delete_account(record?.id)}
            okText="Yes"
            cancelText="No"
            disabled={record?.status === false}
          >
            <Button variant="solid" color="red" size="small" disabled={record?.status === false}>
              Delete App User
            </Button>
          </Popconfirm>
        </Space>
      ),
    },

  ];


  const delete_account = async (id) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);
    try {
      const response = await DELETE_ACCOUNT(FORM_DATA);
      if (response?.data?.status) {
        notification.success({
          message: "Deleted Successfully",
          description: response?.data?.message,
        });
        // Refresh the table after deletion
        LIST_API();
      } else {
        message.error(response?.data?.message || "Failed to delete");
      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    } finally {
      set_pagination_loader(false);
    }
  };


  return (

    <div className="lms-body">

      <Card>
        <Row>
          <Col span={12}>
            <h2>Account Delete Requests {page ? `(Page ${page})` : ""}</h2>
          </Col>

        </Row>

        <Row>
          <Col span={12}>
            <Input
              addonBefore={selectBefore}
              placeholder={placeholder}
              onChange={handleInput}
              size="large"
            />
          </Col>
        </Row>

        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            {pagination_loader ? (
              <>
                <div style={{ textAlign: "center", padding: "60px" }}>
                  <Spin indicator={<LoadingOutlined spin />} size="large" />
                </div>
              </>
            ) : (
              <>
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={table_data}
                  style={{ marginTop: "15px" }}
                  rowKey="id"
                  scroll={{ x: "max-content" }}
                />
              </>
            )}

            {total_pages > 0 ? (
              <>
                <div style={{ float: "right", marginTop: "20px" }}>
                  {" "}
                  <Pagination
                    current={current_page}
                    total={total_count}
                    pageSize={page_size}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={pagination_on_change}
                    onShowSizeChange={(current, size) => {
                      set_page_size(size);
                      pagination_on_change(1, size);
                    }}
                    style={{ display: 'inline-block' }}
                    className="no-search-pagination"
                  />
                  <style>
                    {`
                      .no-search-pagination .ant-select-selection-search-input {
                        display: none !important;
                      }
                    `}
                  </style>
                </div>
              </>
            ) : (
              <>
                <div style={{ textAlign: "center", color: "red" }}>
                  {/* <h2>No App User Found</h2> */}
                </div>
              </>
            )}
          </>
        )}




      </Card>
    </div>
  );
}

export default AccountDeleteRequests;
